import React from "react";

import styled from "@emotion/styled";
import { LoadingButton } from "@mui/lab";

const StyledButton = styled(LoadingButton)`
  transition: all 0.2s ease-in-out;
  &.MuiLoadingButton-loading {
    background-color: ${(props) =>
      props.color === "error"
        ? props.theme.palette.error.dark
        : props.theme.palette.primary.dark};
  }
  .MuiLoadingButton-loadingIndicator {
    color: ${(props) => props.theme.palette.common.white};
  }
`;
const CustomLoadingButton = ({ loading, children, ...props }) => {
  return (
    <StyledButton loading={loading} {...props}>
      {children}
    </StyledButton>
  );
};
export default CustomLoadingButton;
